import React from 'react'
import M3Logo from "../../assets/images/name_logo.png"; 


const ShowMessageWhenUnSelect = () => {
  return (
    <div className="h-full w-full flex flex-col justify-center items-center text-center">
        <div className="mb-4">
          <img src={M3Logo} width={250} alt="M3 Logo" />
        </div>
        <p className="text-xl text-center pb-1 border-2 text-gray-400 border-gray-400 mb-3 rounded-md p-2">
            You are on Mawhiba Meta Mind Communication
        </p>
        <h2 className="text-orange-500 text-center mb-2 border-2 border-orange-500 rounded-md px-4 py-2">
            You Can Chat Now
        </h2>
    </div>
  )
}

export default ShowMessageWhenUnSelect
